import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { AccountAirdropSummary } from '../types'
import { DashboardViewProps } from '../views/DashboardView'
import { AirdropClaimsQueryData } from './airdropClaimsQuery'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { useSpkTokenRepository } from '@/features/spk/common/useSpkTokenRepository'
import { OpenStakeWithDelegateDialogFunction } from '@/features/spk/staking/dialogs/stake/useOpenStakeWithDelegateDialog'

export interface UseDashboardViewPropsParams {
  accountAirdropSummary: AccountAirdropSummary
  accountAirdropClaims: AirdropClaimsQueryData
  accountSpkStakedAmount: NormalizedNumber
  chainId: number
  openStakeSpkDialog: OpenStakeWithDelegateDialogFunction
}

export function useDashboardViewProps({
  accountAirdropSummary,
  chainId,
  openStakeSpkDialog,
}: UseDashboardViewPropsParams): DashboardViewProps {
  const { account } = useConnectedAddress({ throwOnNotConnected: false })
  const spk = useSpkTokenRepository({ chainId, account }).findOneBySymbol(TokenSymbol('SPK'))
  const airdrops = accountAirdropSummary?.airdrops ?? []

  return {
    spk,
    alreadyClaimedAirdrop: accountAirdropSummary.totalClaimed,
    airdrops,
    totalAllocation: accountAirdropSummary.totalAllocation,
    totalClaimedAllocation: accountAirdropSummary.totalClaimed,
    totalExpiredAllocation: accountAirdropSummary.totalUnclaimed,
    stake: () =>
      openStakeSpkDialog({
        successViewProceedText: 'Back to My Airdrop',
      }),
  } satisfies DashboardViewProps
}
